import type { AppConfig } from '@/types';

export const appConfigData: AppConfig = {
  appTitle: 'Hall',
  idleTimeout: 180,
  color: '35 31 32',
  backgroundColor: '230 245 241',
};
